import { styled } from '@mui/material/styles';

export const SubTitle = styled('h4')(() => ({
  color: '#0F0F10',
  fontWeight: 700,
  fontSize: '1.063rem',
  marginRight: 20,
  width: 210,
}));
